declare namespace $ {

	export class $shm_hitalama_vk_lists_editing extends $shm_hitalama_vk_lists_creating {
		title( ): string
		param( ): string
		list( ): $shm_hitalama_vk_list
	}
	
}

//# sourceMappingURL=editing.view.tree.d.ts.map